<div id="headerInfo" [dir]="direction">
  <ng-container *ngIf="isNewAILayout">
    <div *ngIf="!isStoreLogo" class="ptl-store-logo-section"
      [ngClass]="{'ptl-store-logo-background': isPantherLakeStd,
          'ptl-12xe-store-logo-background': !isPantherLakeStd,
          'ptl-onboarding-logo-section': activeTabQueryParam === 'onboarding' && !currentUrl.includes('/specs/'), 
          'ptl-gaming-store-logo-background': isPantherLakeGaming,
          'wcl-std-store-logo-background': isWildCatLakeStd
          }">
      <img class="ptl-store-logo-image" [src]="storeLogo" alt="STORE LOGO">
    </div>
    <div class="ptl-header-section" *ngIf="shouldShowNavbar" [ngClass]="{'ptl-std-header': isPantherLakeStd, 'ptl-gaming-header': isPantherLakeGaming, 'intelOne-display': setFontIntelDisplayOne, 'wcl-std-header': isWildCatLakeStd}">
      <span class="ptl-device-name" [innerHTML]="isNewAILayout ? deviceDetails?.specTitle : (deviceDetails?.specTitle.length > 35  ? (deviceDetails?.specTitle | slice:0:35) + '...' : deviceDetails?.specTitle)"></span>
      <span *ngIf="price && deviceDetails?.specTitle" class="divider"></span>
      <span>{{price}}</span>
      <div class="language-section" [ngClass]="rtlLangs.includes(language ) ? 'rtl-language-section' : ''">
        <span class="lang-text" [ngClass]="isPantherLakeStd ? 'lang-black-text' : 'lang-white-text'">{{ languageShortCode }}</span>
        <img [src]="languageGlobeIcon" class="lang-icon" alt="language"/>
      </div>
    </div>
    <nav #navbarRef class="navbar" *ngIf="activeTabQueryParam !== 'onboarding'" [ngClass]="{'ptl-std-navbar': isPantherLakeStd, 'ptl-gaming-navbar': isPantherLakeGaming, 'intelOne-display': setFontIntelDisplayOne, 'align-item-center': !showVirtualAssistant, 'wcl-std-navbar': isWildCatLakeStd}">
      <ul class="navbar-list">
        <li #navItemRef class="navbar-item" routerLinkActive="active">
          <a [routerLink]="[]" [queryParams]="{ activeTab: 'overview' }" (click)="onNavClick('overview')" [innerHTML]="navigationTabText?.tr_overview"></a>
        </li>
        <li #navItemRef class="navbar-item" routerLinkActive="active">
          <a [routerLink]="[]" [queryParams]="{ activeTab: 'specs' }" (click)="onNavClick('specs')" [innerHTML]="navigationTabText?.tr_specs"></a>
        </li>
        <li #navItemRef *ngIf="promoLength>0" class="navbar-item" routerLinkActive="active">
          <a [routerLink]="[]" [queryParams]="{ activeTab: 'promos' }" (click)="onNavClick('promos')" [innerHTML]="navigationTabText?.tr_promos"></a>
        </li>
        <li #navItemRef class="navbar-item" routerLinkActive="active" *ngIf="showVirtualAssistant">
          <a [routerLink]="[]" [queryParams]="{ activeTab: 'va' }" (click)="onNavClick('va')" [innerHTML]="navigationTabText?.tr_virtualAssistant"></a>
        </li>
        <li #navItemRef class="navbar-item compare-item" routerLinkActive="active">
          <a [routerLink]="[]" [queryParams]="{ activeTab: 'compare' }" (click)="onNavClick('compare')" [innerHTML]="navigationTabText?.tr_compareDevices"></a>
        </li>
      </ul>
    </nav>
    <div class="ptl-back-header-button" *ngIf="showBackButton && activeTabQueryParam != 'overview'" [ngClass]="{'ptl-std-back-button': isPantherLakeStd, 'wcl-std-back-button':isWildCatLakeStd ,'intelOne-display': setFontIntelDisplayOne, 'ptl-gaming-backBtn' : isPantherLakeGaming}">
      <img [src]=backArrowImgSrc alt="ptl back arrow" (click)="goBackToPreviousPage()"/>
      <label (click)="goBackToPreviousPage()" [innerHTML]="backButtonText"></label>
    </div>
  </ng-container>
  <ng-container *ngIf="!isNewAILayout">
    <div id="mobileHeaderMainLayout" class=mobile_header *ngIf="isMainLayout" [ngClass]="!deviceDetails.specTitle && !deviceDetails.deviceLogo ? 'rem_height': ''" [class.mobile-header-chromebook]="isChromeBook" [class.ai-ipos-header]="isAiIpos"> <!-- II-3382 -->
      <div id="allSpecsInfo" class="d-flex align-items-center">
        <span *ngIf="(router.url == '/all-specs')">
          <img [ngClass]="!isChromeBook ? 'left_arrow_icon' : 'left_arrow_icon_black'" alt="left arrow icon" (click)="goToOffline()"></span>
          <div id="deviceDetailsSpecTitle" *ngIf="deviceDetails.specTitle"> <!-- IJR-3529 -->
            <span class="flex"><img src="../../../assets/images/{{deviceDetails.deviceLogo}}.svg"
                alt="partner logo" class="image-margin logo-styles" onerror="this.style.display='none'"> <!--IJR-3611 fix added onerroe-->
              <span class="mt-2 intelOne-display"
                [ngClass]="isStandardEnhancement ? 'std12_text' : ''" [innerHTML]="deviceDetails?.specTitle"></span></span>
          </div>
      </div>
      <div *ngIf="isEvoMTL || isEvoArl">
        <img src="../../../assets/images/evo/mtl-arl_lnl-evo.png" class="arl-lnl-evo" alt="Intel-EVO" />
      </div>
      
    </div>
    <div id="chromebookMobileHeader" class="mobile_header" *ngIf="!isMainLayout && !isNewHeader" [class.mobile-header-chromebook]="isChromeBook"> <!--chromebook-->
      <div id="displayPageName" [class.page_name_nonintel]="isNonIntel" class="page_name"  [ngClass]="setFontIntelDisplayOne ? 'intelOne-display':'latin-bold'" [innerHTML]="displayPageName"></div> <!-- GLS-301308 -->
      <div id="mobileCloseIcon" class="mobile-closeicon">
        <img (click)="closeLayout()" src="../../../assets/images/close-button.svg" alt="close" /> <!-- IJR-845 -->
      </div>
    </div>
    <!-- IJR-1736 12th genGaming starts -->
    <div id="gaming12Gen" class="d-flex new-mobile_header detailed-header" *ngIf="!isMainLayout && isNewHeader" [class.ai-ipos-header]="isAiIpos" >
      <div id="homeLogo" *ngIf = "homePagecount > 2" class="mobile-header-home-icon" [class.std12_home_icon_background]="isStandardEnhancement || is11GenCreator" [class.evo_home_icon_background]="isEvo" [class.std11_home_icon_background]="contentType==='S11'" (click)="goHome()">
          <span><img class="mobile-home-icon" alt="home logo"></span>
      </div>
      <div id="mobileBgHeader" class="mobile-bg-header">
          <div class="row align-item">
              <div id="headerFactTagName" [class.intelOne-display]="setFontIntelDisplayOne" [class.clear-font-bold]="!setFontIntelDisplayOne" class="header-fact-tag-names">
                <span [ngClass]="isStandardEnhancement ? 'std12_text' : ''" [innerHTML]="displayPageName"></span>
              </div>
              <div id="headerCloseIcon" class="header-cross-img">
                  <img [ngClass]="isStandardEnhancement ? 'std12_close_btn': 'new-close-icon'" alt="close logo" (click)="goBack()">
              </div>
          </div>
      </div>
    </div>
  </ng-container>
<!-- IJR-1736 12th genGaming ends -->
</div>
